import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { PaisService } from './services/pais.service';
import { IPais } from './interfaces/pais.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-paises',
  templateUrl: './paises.component.html',
  providers: [MessageService]
})
export class PaisesComponent implements OnInit {
  @ViewChild('dt') table!: Table;

  displayDialog: boolean = false;
  selectedPais: IPais | null = null;
  dataSource: IPais[] = [];
  loading: boolean = false;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  displayedColumns = [
    { field: 'clave_Pais', header: 'Clave País', sortable: true },
    { field: 'descripcion', header: 'Descripción', sortable: true },
    { field: 'moneda', header: 'Clave Moneda', sortable: true },
    { field: 'actions', header: 'Acciones', sortable: false }
  ];

  constructor(
    private messageService: MessageService,
    private paisService: PaisService,
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    this.paisService.getPaises().subscribe({
      next: (response) => {
        if (response.success) {
          this.dataSource = response.data;
          this.totalRecords = response.data.length;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar los países'
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al cargar países:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar los países'
        });
        this.loading = false;
      }
    });
  }

  openCreate(): void {
    this.selectedPais = null;
    this.displayDialog = true;
  }

  openUpdate(row: IPais): void {
    this.selectedPais = { ...row };
    this.displayDialog = true;
  }

  openDelete(row: IPais): void {
    this.deletePais(row.clave_Pais);
  }

  onDialogClosed(): void {
    this.selectedPais = null;
    this.displayDialog = false;
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
    this.loadData();
  }

  onSave(result: { success: boolean; message: string }): void {
    if (result?.success) {
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: result.message
      });
    }
    this.displayDialog = false;
    this.loadData();
  }

  deletePais(clavePais: string): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: '¿Desea eliminar este país?',
      icon: 'warning',
      showCancelButton: true,
      iconColor: '#d33',
      confirmButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.paisService.deletePais(clavePais).subscribe({
          next: (response) => {
            if (response.success) {
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'País eliminado exitosamente'
              });
              this.loadData();
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: response.data?.error || 'No se pudo eliminar el país'
              });
            }
            this.loading = false;
          },
          error: (error) => {
            console.error('Error al eliminar país:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error al eliminar el país'
            });
            this.loading = false;
          }
        });
      }
    });
  }
} 